import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../auth/useAuth';

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading, login } = useAuth();
  const location = useLocation();
  const redirectStarted = useRef(false);

  useEffect(() => {
    if (isLoading || isAuthenticated || redirectStarted.current) return;

    redirectStarted.current = true;
    sessionStorage.setItem('auth_return_to', location.pathname + location.search);
    login();
  }, [isAuthenticated, isLoading, location.pathname, location.search, login]);

  if (isLoading) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }} role="status" aria-live="polite">
        <p>Loading…</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }} role="status" aria-live="polite">
        <p>Redirecting to sign in…</p>
      </div>
    );
  }

  return <>{children}</>;
}
